<template>
  <div class="page page_faq">
    <FaqHero />
    <FaqAccordion />
  </div>
</template>

<script>
import FaqHero from '@/components/faq/FaqHero.vue'
import FaqAccordion from '@/components/faq/FaqAccordion.vue'

export default {
  name: 'Faq',
  components: { FaqHero, FaqAccordion }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.page {
  padding: 0;
  max-width: none;
  margin: 0;

  &_faq {
    min-height: auto;
  }
}
</style>
